import { ButtonAsLink } from '@cluey/cluey-components';
import { useEffect, useState } from 'react';

const COOLDOWN_SECONDS = 60;

export type ResendCodeButtonProps = {
  onClick: () => void;
};

const ResendCodeButton = ({ onClick }: ResendCodeButtonProps) => {
  const [secondsLeft, setSecondsLeft] = useState(0);

  useEffect(() => {
    if (secondsLeft <= 0) return;
    const id = setInterval(() => setSecondsLeft((s) => s - 1), 1000);
    return () => clearInterval(id);
  }, [secondsLeft]);

  const handleResend = () => {
    onClick();
    setSecondsLeft(COOLDOWN_SECONDS);
  };

  const canResend = secondsLeft === 0;

  return (
    <p>
      Didn't receive the code?{' '}
      <ButtonAsLink size="base" onClick={canResend ? handleResend : undefined} disabled={!canResend}>
        Resend email
      </ButtonAsLink>
      {!canResend && <span className="ml-1">in {secondsLeft}s</span>}
    </p>
  );
};

export default ResendCodeButton;
